module.exports = __webpack_public_path__ + "img/901393028.a04f68b9.png";